import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "size"],
  _excluded2 = ["color", "size"],
  _excluded3 = ["name", "color", "size"];
import styled, { theme } from '../../utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CheckmarkIcon = props => {
  return /*#__PURE__*/_jsxs("svg", Object.assign({
    role: "img",
    version: "1.1",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [/*#__PURE__*/_jsx("title", {
      children: "Check"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("filter", {
        id: "filter-1",
        children: /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceGraphic",
          type: "matrix",
          values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.31063462,0.996062609 L2.55782692,4.8356342 L0.689365385,2.92424979 C0.531596154,2.76283298 0.276096154,2.76283298 0.118326923,2.92424979 C-0.0394423077,3.0856666 -0.0394423077,3.34707369 0.118326923,3.5084905 L2.27217308,5.712133 C2.35105769,5.7928414 2.45444231,5.83333333 2.55782692,5.83333333 C2.66094231,5.83333333 2.76432692,5.7928414 2.84321154,5.712133 L6.88167308,1.58030332 C7.03944231,1.41888651 7.03944231,1.15747942 6.88167308,0.996062609 C6.72390385,0.834645797 6.46840385,0.834645797 6.31063462,0.996062609",
        id: "path-2"
      })]
    }), /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      id: "User-Guide-Academy-Prominence-STATS",
      stroke: "none",
      strokeWidth: "1",
      children: /*#__PURE__*/_jsx("g", {
        id: "Software-landing-page",
        transform: "translate(-1030.000000, -1267.000000)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Copy-and-screen",
          transform: "translate(184.000000, 383.000000)",
          children: /*#__PURE__*/_jsx("g", {
            id: "Group-10-Copy-2",
            transform: "translate(846.000000, 879.000000)",
            children: /*#__PURE__*/_jsxs("g", {
              id: "Check",
              transform: "translate(0.000000, 5.000000)",
              children: [/*#__PURE__*/_jsx("g", {
                fill: "currentColor",
                id: "Icons/Feedback&Ratings/Favorite/circleFilled",
                children: /*#__PURE__*/_jsx("circle", {
                  cx: "7.5",
                  cy: "7.5",
                  id: "Oval",
                  r: "7.5"
                })
              }), /*#__PURE__*/_jsx("g", {
                filter: "url(#filter-1)",
                id: "Icons/Actions/Add",
                transform: "translate(4.000000, 4.000000)",
                children: /*#__PURE__*/_jsxs("g", {
                  children: [/*#__PURE__*/_jsx("mask", {
                    fill: "white",
                    id: "mask-3",
                    children: /*#__PURE__*/_jsx("use", {
                      xlinkHref: "#path-2"
                    })
                  }), /*#__PURE__*/_jsx("use", {
                    fill: "currentColor",
                    id: "Icons/Utilities/Success",
                    xlinkHref: "#path-2"
                  })]
                })
              })]
            })
          })
        })
      })
    })]
  }));
};
const VideoIcon = _ref => {
  let {
      color,
      size
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", Object.assign({
    color: color,
    fill: "none",
    height: size,
    viewBox: "0 0 22 22",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      clipRule: "evenodd",
      d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM15.3218 9.7381L9.45005 5.13902C9.22129 4.96015 8.93491 4.96015 8.70615 5.10307C8.47739 5.26439 8.33333 5.56906 8.33333 5.90838V15.0869C8.33333 15.4091 8.47652 15.7309 8.70615 15.8926C8.82097 15.9641 8.93491 16 9.06413 16C9.20732 16 9.33567 15.9641 9.45092 15.8562L15.3227 11.276C15.5374 11.1142 15.6667 10.81 15.6667 10.5066C15.6667 10.2032 15.5514 9.89856 15.3227 9.73724L15.3218 9.7381Z",
      fill: "#7C98B6",
      fillRule: "evenodd"
    })
  }));
};
const QuizIcon = _ref2 => {
  let {
      color,
      size
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx("svg", Object.assign({
    color: color,
    fill: "none",
    height: size,
    viewBox: "0 0 22 22",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      clipRule: "evenodd",
      d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11.4174 14.5259C10.8535 14.5259 10.3959 14.0375 10.3959 13.4358V11.8007C10.3959 11.1989 10.8535 10.7106 11.4174 10.7106C12.5881 10.7106 13.5402 9.69462 13.5402 8.44538C13.5402 7.19614 12.5881 6.17963 11.4174 6.17963C10.5067 6.17963 9.69814 6.79771 9.40598 7.7172C9.22516 8.28732 8.64441 8.59309 8.11013 8.39905C7.57586 8.20556 7.28982 7.58693 7.47115 7.01682C8.04475 5.21218 9.63072 4 11.4174 4C13.7144 4 15.5833 5.99432 15.5833 8.44538C15.5833 10.5204 14.2436 12.2678 12.439 12.7556V13.4358C12.439 14.0375 11.9813 14.5259 11.4174 14.5259ZM12.439 16.9099C12.439 17.5116 11.9813 18 11.4174 18C10.8535 18 10.3959 17.5116 10.3959 16.9099C10.3959 16.3082 10.8535 15.8198 11.4174 15.8198C11.9813 15.8198 12.439 16.3082 12.439 16.9099Z",
      fill: "#7C98B6",
      fillRule: "evenodd"
    })
  }));
};
const StyledCheckmarkIcon = styled(CheckmarkIcon).withConfig({
  displayName: "ACIcon__StyledCheckmarkIcon",
  componentId: "gn2i93-0"
})(["color:", ";width:", "px;height:", "px;"], ({
  color
}) => color, ({
  size
}) => size, ({
  size
}) => size);
const ACIcon = _ref3 => {
  let {
      name,
      color = theme.colors.EERIE,
      size = 14
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  if (name === 'checkmark') return /*#__PURE__*/_jsx(StyledCheckmarkIcon, Object.assign({
    color: color,
    size: size
  }, props));
  if (name === 'video') return /*#__PURE__*/_jsx(VideoIcon, Object.assign({
    color: color,
    size: size
  }, props));
  if (name === 'quiz') return /*#__PURE__*/_jsx(QuizIcon, Object.assign({
    color: color,
    size: size
  }, props));
  return null;
};
export default ACIcon;